export const ACCREDITATION_BIO = 'ACCREDITATION_BIO';
export const ACCREDITATION_BIO_STATUS = 'ACCREDITATION_BIO_STATUS';

export const accreditationBio = (obj) => (dispatch) => {
  if (obj) {
    dispatch({
      type: ACCREDITATION_BIO,
      payload: { ...obj },
    });
  }
};

export const accreditationBioStatus = (array) => (dispatch) => {
  if (array) {
    dispatch({
      type: ACCREDITATION_BIO_STATUS,
      payload: [...array],
    });
  }
};
